import * as React from "react";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";
import ApplicationStatusMessageEditButton from "./ApplicationStatusMessageEditButton";
import ApplicationStatusMessageActivateContainer from "./ApplicationStatusMessageActivateContainer";
import ApplicationStatusMessageDeleteContainer from "./ApplicationStatusMessageDeleteContainer";

const columnConfigs: ColumnConfig[] = [
  {
    name: "Category",
    render: (row) => row.category,
  },
  {
    name: "Level",
    render: (row) => row.level,
  },
  {
    name: "Message body",
    render: (row) => row.message_body,
  },
  {
    name: "Activate",
    render: (row) => (
      <ApplicationStatusMessageActivateContainer statusMessage={row} />
    ),
  },
  {
    name: "Edit",
    render: (row) => {
      return <ApplicationStatusMessageEditButton statusMessage={row} />;
    },
  },
  {
    name: "Delete",
    render: (row) => {
      return <ApplicationStatusMessageDeleteContainer statusMessage={row} />;
    },
  },
];

export default columnConfigs;
